/* @flow */

export function getReduxFormError(meta: {error: ?string, submitFailed: boolean}): ?string {
    return meta.error && meta.submitFailed ? meta.error : null;
}
